import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'fitech-workspace-mat-select-search',
	templateUrl: './mat-select-search.component.html',
	styleUrls: ['./mat-select-search.component.scss'],
})
export class MatSelectSearchComponent implements OnInit, OnDestroy {
	@Input() searchControl: FormControl<string>;
	@Input() placeholder = 'Search';
	@Input() noResultsText = 'No results';
	@Input() isNoResults = false;
	@Input() isSelectOpened: boolean;
	@Input() isSelectButtons = false;

	@Output() setFormControl = new EventEmitter<FormControl<string>>();

	@ViewChild('searchInput') private _searchInputRef: ElementRef<HTMLInputElement>;

	ngOnInit(): void {
		if (!this.searchControl) {
			this.searchControl = new FormControl('');
			this.setFormControl.emit(this.searchControl);
		}
	}

	ngOnDestroy(): void {
		this.clearValue();
	}

	toggleSelect(isOpened: boolean): void {
		if (isOpened) {
			this.focus();
		} else {
			this.clearValue();
		}
	}

	clearValue(autoFocus: boolean = false): void {
		if (this.searchControl.value === '') {
			return;
		}

		this.searchControl.setValue('');

		if (autoFocus) {
			this.focus();
		}
	}

	private focus(): void {
		this._searchInputRef.nativeElement.focus();
	}
}
